import { withChartLayout } from 'components/common';
import MentalStatus from 'components/features/chart/provider-chart/history-physical/mental-status/MentalStatus';

const MentalStatusPage = withChartLayout('Mental Status')(MentalStatus);
export default MentalStatusPage;
